import { useQuery } from '@tanstack/react-query';

import type {
  RealtorInfoType,
  RealtorMemulListParamsType,
} from '@/app/(realtor)/realtor/[realtorCd]/type';
import { customFetch } from '@/service/commonFetch';
import { MemulListType } from '@/service/commonType';
import queryKeyFactory from '@/service/queryKeyFactory';

export const useRealtorInfo = (realtorCd: string) =>
  useQuery({
    queryKey: queryKeyFactory.realtor.info(realtorCd),
    queryFn: () => getRealtorInfo(realtorCd),
    select: (data) => data.data,
  });

export const getRealtorInfo = async (realtorCd: string) => {
  return await customFetch<RealtorInfoType>(`/agency/detail`, {
    params: { agencyNo: realtorCd },
    next: {
      revalidate: 60,
      tags: queryKeyFactory.realtor.info(realtorCd),
    },
  });
};

export const realtorMemulListQuery = (params: RealtorMemulListParamsType) => ({
  queryKey: queryKeyFactory.realtor.memulList(params),
  queryFn: ({ pageParam }: { pageParam: number }) =>
    customFetch<MemulListType>(`/agency/offerings`, {
      params: { page: pageParam, ...params },
    }),
});

export const getRealtorMemulList = async (params: RealtorMemulListParamsType) => {
  return await customFetch<MemulListType>(`/agency/offerings`, {
    params,
    next: {
      tags: queryKeyFactory.realtor.memulList(params),
      revalidate: 60,
    },
  });
};
